import { ApiConfig } from '../http/api.config';

const authApiBase = `${ApiConfig.BaseUrl}/api/Auth`;

export const AuthApiRoutes = {
  Login: `${authApiBase}/login`,
  ForgotPassword: `${authApiBase}/forgot-password`,
  ResetPassword: `${authApiBase}/reset-password`,
  CurrentUser: `${authApiBase}/me`,
  Profile: `${authApiBase}/profile`,
  ProfilePhoto: `${authApiBase}/profile/photo`,
  ChangePassword: `${authApiBase}/change-password`,
  Language: `${authApiBase}/language`,
  Logout: `${authApiBase}/logout`,
} as const;
